var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LayoutContainer"},[_c('Header'),_c('app-main'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }